<template>
  <div class="home">
    <b-container id="helloword">
      <div class="hello">
        <p>{{ mensaje }}</p>
        <p>{{leyenda}}</p>
      </div>
    </b-container>
   <div>
     <b-container >
        <InputInicio /> 
     </b-container>
   </div>
  </div>
</template> 

<script>
// @ is an alias to /src
import InputInicio from '../components/InputInicio.vue'


export default {
  name: 'Home',
  components: {
    InputInicio,

  },
  data() {
    return {
      mensaje: 'Búsquedas en el archivo bibliográfico',
      leyenda: `Inserta una o varias palabras a buscar dentro de las cajas de texto. 
                SIABUC localizará las fichas de los libros que contengan estas palabras`,
    }
  },
}
</script>

<style scoped>

  .home{
   
  }

  #helloword{
    width: 100%;
    color:gray;
    background-color:#F1EBD5;
    margin-bottom: 1%;
    padding-bottom: 1%;
  }
  p{
    margin-bottom: .5rem !important;
  }

</style>

